import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUpDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.246 13.227V4.555l-.967.969a.749.749 0 0 1-1.06-1.06L4.466 2.22a.75.75 0 0 1 1.059 0L7.77 4.465a.749.749 0 0 1-1.06 1.06l-.966-.97v8.672a.749.749 0 1 1-1.498 0m6.204.53L8.205 11.51a.75.75 0 0 1 1.06-1.059l.967.968V2.75a.748.748 0 0 1 1.497 0v8.67l.968-.967a.749.749 0 1 1 1.059 1.059l-2.244 2.245a.75.75 0 0 1-1.06 0z" }));
const ForwardRef = forwardRef(SvgArrowUpDown);
export { ForwardRef as ReactComponent };
